'use client'

import { useTranslations } from 'next-intl'

import { useDialogState } from '@/shared/lib'
import { Button } from '@/shared/ui'

import { PASSPORT_EMAIL_VERIFICATION_DIALOG } from './passport-email-dialog'

export const PassportEmailVerificationButton = () => {
  const t = useTranslations()

  const { open } = useDialogState()

  const handleClick = () => {
    open(PASSPORT_EMAIL_VERIFICATION_DIALOG, { closeOnOpen: true })
  }

  return (
    <Button
      variant="outline"
      shape="pill"
      size="medium"
      className="typo-label1 w-full"
      onClick={handleClick}
    >
      {t('verification.button.verify_passport_and_email')}
    </Button>
  )
}
